import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { BlocCompétencesService } from '../bloc-competences/bloc-compétences.service';
import { BlocCompétencesStore } from '../bloc-competences/store/bloc-compétences.store';
import { BlocCompétences } from '../croisement-référentiel/models/bloc-compétences';

export const blocResolver: ResolveFn<Observable<BlocCompétences>> = (route) => {
  const blocStore = inject(BlocCompétencesStore);
  const blocService = inject(BlocCompétencesService);
  const codeBloc = route.params['codeBloc'] as string;

  const slug = route.params['slugRef'] as string;
  const fragments = !!slug ? slug.split('-') : [];
  const idReferentiel = fragments.length ? fragments[0] : '';

  return blocService.parCodeBloc(codeBloc, idReferentiel).pipe(
    tap((bloc) => {
      blocStore.ajouterBloc({ bloc });
      blocStore.selectionerBloc({ codeBloc: bloc.codeBloc });
    }),
  );
};
